import { IScriptedExactOnlineConfiguration } from 'interfaces';
import { Registry } from '.';

export interface ExactOnlineTopicConfigurationDto { userConfig: string; defaultConfig: string; }

export default ({ get, post, destroy }: Registry) => {
  return {
    exactOnline: {
      downloadBrowserExtension: (): Promise<any> => get('/api/v1/exact_online_extension/latest_extension_bundle'),
      browserExtensionConfig: {
        scripting: {
          getAll: (): Promise<{ script: IScriptedExactOnlineConfiguration, loaded: boolean }[]> => get('/api/v1/exact_online_extension/config/scripts'),
          save: (script: IScriptedExactOnlineConfiguration) => post('/api/v1/exact_online_extension/config/scripts', script),
          delete: (id: number) => destroy(`/api/v1/exact_online_extension/config/scripts/${id}`),
        }
      },
      databaseMonitor: {
        getTopicConfiguration: () => get<ExactOnlineTopicConfigurationDto>('/api/v1/exact_online_database/topicConfiguration'),
        saveTopicConfiguration: (data: string) => post('/api/v1/exact_online_database/topicConfiguration', { data }),

        getCallStats: () => get<{ performed: number; allowed: number; }>('/api/v1/exact_online_database/calls'),
        getTopicMetaData: () => get<{ name: string; currentlyRunning: boolean; currentlyRunningType: string; mightRequireFullLoad: boolean; allowReFetchSince: boolean; localCount: boolean; }[]>('/api/v1/exact_online_database/topic_states'),
        performCountCheck: (topic: string) => post<{ eoCount:number; myCount:number; }>('/api/v1/exact_online_database/topic_states/count_check', { topic }),
        performSync: (topic: string) => post('/api/v1/exact_online_database/topic_states/perform_sync', { topic }),
        performFullSync: (topic: string, recreateTables: boolean) => post(`/api/v1/exact_online_database/topic_states/perform_full_sync/${recreateTables}`, { topic }),
        performSyncSince: (topic: string, since: string) => post('/api/v1/exact_online_database/topic_states/perform_sync_since', { topic, since }),
        performRecheckDeleted: (days: number) => post(`/api/v1/exact_online_database/topic_states/recheck_deleted/${days}`, {}),
        fetchMetadata: (topic: string) => post<{ result: string; }>('/api/v1/exact_online_database/topic_states/fetchMetaData', { topic }),
      }
    },
  };
};
